import React, { FC } from 'react';
import { ActionItemList, ActionPropsWithId, Grid, GridItem } from '@modernhealth/vital-components';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { ContentCardProps } from './ContentCard';
import { mapContentLinkToActionItemProps } from '../helpers/contentLinkNodeToActionItem';

export const VerticalContentCard: FC<ContentCardProps> = ({ links }) => {
    const { showCirclesInMemberWeb } = useFlags();

    if (!links) {
        return null;
    }

    const mappedLinks = links
        .map(link => mapContentLinkToActionItemProps(link, showCirclesInMemberWeb))
        .filter((link): link is ActionPropsWithId => link !== null)
        .reduce<ActionPropsWithId[][]>((mapped, circle, i) => {
            const index = i % 3;
            const elem = mapped[index];
            if (!elem) {
                mapped[index] = [circle];
            } else {
                mapped[index] = [...elem, circle];
            }
            return mapped;
        }, []);

    return (
        <Grid lgMode="3columns">
            {mappedLinks.map((circles, i) => {
                const hideWidth = i === 1 ? 'sm' : 'md';
                return (
                    <GridItem
                        lg={1}
                        md={2}
                        column
                        hide={i > 0 ? hideWidth : undefined}
                        key={`actionItemList_column_${i}`}
                    >
                        <ActionItemList actions={circles} />
                    </GridItem>
                );
            })}
        </Grid>
    );
};
